(function () {
  var container = document.querySelector('.product__description');
  if (!container) return;

  var allHeadings = container.querySelectorAll('h3');
  // Filter out headings that belong to product specs (not description content)
  var headings = [];
  allHeadings.forEach(function (h3) {
    if (!h3.classList.contains('product-specs__group-title')) {
      headings.push(h3);
    }
  });
  if (headings.length < 2) return;

  // Collect sections: each h3 starts a section, content runs until next h3
  var sections = [];
  headings.forEach(function (h3) {
    var title = h3.textContent.trim();
    if (!title) return;

    var content = [];
    var sibling = h3.nextElementSibling;
    while (sibling && sibling.tagName !== 'H3') {
      content.push(sibling);
      sibling = sibling.nextElementSibling;
    }
    if (content.length === 0) return;
    sections.push({ heading: h3, title: title, content: content });
  });

  if (sections.length < 2) return;

  // Build accordion
  var accordion = document.createElement('div');
  accordion.className = 'desc-accordion';

  function closePanel(b) {
    // From an uncapped ('none') panel, pin a concrete height first so the
    // transition to 0 can animate.
    if (b.style.maxHeight === 'none' || b.style.maxHeight === '') {
      b.style.maxHeight = b.scrollHeight + 'px';
      b.offsetHeight; // force reflow
    }
    b.classList.remove('is-open');
    b.style.maxHeight = null;
  }

  function openPanel(b) {
    // Animate to measured height, then release the cap so content is never
    // clipped if the measured height was short (fonts/layout not settled).
    b.classList.add('is-open');
    b.style.maxHeight = b.scrollHeight + 'px';
    var release = function (e) {
      if (e && e.propertyName !== 'max-height') return;
      if (b.classList.contains('is-open')) b.style.maxHeight = 'none';
      b.removeEventListener('transitionend', release);
    };
    b.addEventListener('transitionend', release);
  }

  sections.forEach(function (section, i) {
    var panel = document.createElement('div');
    panel.className = 'desc-accordion__panel';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'desc-accordion__trigger';
    trigger.setAttribute('aria-expanded', i === 0 ? 'true' : 'false');
    trigger.innerHTML = '<span>' + section.title + '</span><svg class="desc-accordion__icon" width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var body = document.createElement('div');
    body.className = 'desc-accordion__body';
    if (i === 0) body.classList.add('is-open');

    section.content.forEach(function (el) {
      body.appendChild(el);
    });

    trigger.addEventListener('click', function () {
      var isOpen = body.classList.contains('is-open');

      // Closing the clicked panel: just close it.
      if (isOpen) {
        closePanel(body);
        trigger.setAttribute('aria-expanded', 'false');
        return;
      }

      // Opening: close only the other panels in THIS accordion (never the
      // product-specs accordion), then open the clicked one.
      accordion.querySelectorAll('.desc-accordion__body').forEach(function (b) {
        if (b !== body) closePanel(b);
      });
      accordion.querySelectorAll('.desc-accordion__trigger').forEach(function (t) {
        if (t !== trigger) t.setAttribute('aria-expanded', 'false');
      });
      openPanel(body);
      trigger.setAttribute('aria-expanded', 'true');
    });

    panel.appendChild(trigger);
    panel.appendChild(body);
    accordion.appendChild(panel);
  });

  // Replace original content
  container.innerHTML = '';
  container.appendChild(accordion);

  // Set initial max-height on the open panel
  var openBody = accordion.querySelector('.desc-accordion__body.is-open');
  if (openBody) openBody.style.maxHeight = 'none';
})();
